const apiUrl = process.env.REACT_APP_API_URL;
export const PostVariants = async ( id : number, nom : string, comentaris : string, estat : number, page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8072/alergies`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify({id, nom, comentaris, estat})
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};